const osm = "open-sm";
const otm = "open-tm";
const obl = "open-blocks";
const ful = "fullscreen";

const panelConfig =  {
  stylePrefix: "pn-",

  // Default panels fa-sliders for features
  defaults: [
    {
      id: "commands",
      buttons: [{}],
    },
    {
      id: "options",
      buttons: [
        {
          id: ful,
          className: "fa fa-arrows-alt",
          command: ful,
          context: ful,
          attributes: { title: "Fullscreen" },
        },

      ],
    },
    {
      id: "views",
      buttons: [
        {
            id: obl,
            className: "fa fa-th-large",
            command: obl,
            togglable: 0,
            attributes: { title: "Open Blocks" },
          },
          {
            id: otm,
            className: "fa fa-cog",
            command: otm,
            togglable: 0,
            attributes: { title: "Settings" },
          },
        {
          id: osm,
          className: "fa fa-paint-brush",
          command: osm,
          active: true,
          togglable: 0,
          attributes: { title: "Open Style Manager" },
        },
        
      ],
    },
  ],

  // Editor model
  em: null,

  // Delay before show children buttons (in milliseconds)
  delayBtnsShow: 300,
};

export default panelConfig;